import { LockClosedIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import Link from "next/link";

const MobPlusIndicator = ({
  locked = true,
  size = "base",
  theme = "dark",
  border = false,
  caption = "Unlock this recipe",
}: {
  locked?: boolean;
  size?: "base" | "sm";
  theme?: "dark" | "light";
  border?: boolean;
  caption?: string;
}) => {
  return (
    <>
      {locked && (
        <Link
          href="/premium"
          className={clsx("MobPlusIndicator", "flex items-center gap-x-2")}
          title="A Mob member exclusive"
        >
          <div
            className={clsx("flex items-center justify-center rounded-full ", {
              "bg-zinc-50 text-zinc-700": theme === "dark",
              "bg-zinc-900 text-zinc-50": theme === "light",
              border: border,
              "border-zinc-700": border && theme === "dark",
              "border-zinc-50": border && theme === "light",
              "w-component h-component": size === "base",
              "h-7 w-7": size === "sm",
            })}
          >
            <LockClosedIcon
              className={clsx({
                "h-4 w-4": size === "base",
                "h-3 w-3": size === "sm",
              })}
              aria-hidden="true"
            />
          </div>
          {caption && (
            <div className={clsx("hidden text-base text-rust lg:block")}>
              {caption}
            </div>
          )}
        </Link>
      )}
    </>
  );
};

export default MobPlusIndicator;
